import {useCallback, useMemo, useRef} from 'react'
import {useMappedState} from 'redux-react-hook'
import {treeLevelsMapTickSize} from 'components/TradeView/OrderBook'
import {objectFlip} from 'utils/common'

export const tickSizeMapTreeLevels = objectFlip(treeLevelsMapTickSize)

function getArrayOfDepth (root, tickSize, limit, mergeDesc) {
  let arr = [...root]
  const result = []
  while (arr.length > 0) {
    const n = mergeDesc ? arr.pop() : arr.shift()
    if (n.level === Number(tickSizeMapTreeLevels[tickSize])) {
      const {children, ...others} = n
      result.push(others)
      if (limit && result.length >= limit) break
    } else if (n.children) {
      arr = mergeDesc ? [...arr, ...n.children] : [...n.children, ...arr]
    }
  }
  return result
}

function useOrderbook ({
  symbol, type = 'ask', limit, tickSize, mergeDesc, orderDesc
}) {
  const mapState = useCallback(
    state => ({
      orders: state.orderbook?.[symbol]?.[`${type}Tree`],
      ticker: state?.entities?.tickers?.[symbol] || {}
    }),
    [symbol, type]
  )
  const timeRef = useRef(0)
  const beforeData = useRef([])
  const {
    orders,
    ticker: {lastPrice}
  } = useMappedState(mapState)

  const result = useMemo(() => {
    if (orders) {
      const now = Date.now()
      if (timeRef.current && now - timeRef.current < 500) {
        return beforeData.current
      }
      const list = getArrayOfDepth(orders, tickSize, limit, mergeDesc)
      timeRef.current = now
      beforeData.current = list
      return list
    }
    return []
  }, [orders, tickSize, limit, mergeDesc])
  return orderDesc !== mergeDesc ? result.reverse() : result
}

export default useOrderbook
